import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PlaylistService } from 'src/app/Core/services/playlist.service';
import { UtilService } from 'src/app/Core/services/util.service';

@Component({
  selector: 'app-create-playlist-profile',
  templateUrl: './create-playlist-profile.component.html',
  styleUrls: ['./create-playlist-profile.component.css']
})
export class CreatePlaylistProfileComponent implements OnInit{

    profile:any = {
    playlist_id:'',
    profile_name:'',
    profile_image:'',
    pin:'',
    parental_pin:''
  }
  title:any;
  profilePic:any;
  defaultPic ='/assets/images/userProfile.png';
  categories:any;
  states:any;
  isSubmitting: boolean = false;
  isSecure:boolean = false;

  showPinModal:boolean = false;
  pinError = false;
  pinDigits = new Array(4); // for *ngFor
  enteredPinArray: string[] = ['', '', '', ''];
  reEnteredPinArray: string[] = ['', '', '', ''];

  constructor(private router:Router,private playlistService:PlaylistService,private utilService:UtilService,private route:ActivatedRoute) {
      this.route.queryParams.subscribe(res =>{
        this.profile.playlist_id = res.id
        
      });
       const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state as {
      id: string;
      user_id: string;
      playlist_name: string;
      username:string;
      password: string;
      dns: string;
    };
  
    if (state) {
      console.log(state);
      this.states = state;
    }
  }

  ngOnInit(): void {
      this.getProfileCategory()
  }

  getProfileCategory(){
    this.playlistService.getProfileCategories().subscribe(((res:any)=>{
      this.categories = res.categories;
      console.log(this.categories);
    }))
  }

  // onSubmit(payload:NgForm){
  //   // if(userForm.valid){}
  //   let passModel: any = {
  //    playlist_id:this.profile.playlist_id,
  //    profile_name:this.profile.profile_name,
  //    pin:this.profile.pin,
  //    parental_pin:this.profile.parental_pin,
  //    profile_image:this.defaultPic
  //   };   
  //   if(payload.valid){
  //     console.log(payload,'===',passModel);
  //     this.playlistService.createProfile(passModel).subscribe((res:any)=>{
  //       console.log(res);
  //       if(res){
  //         this.router.navigate(['/profile'],{state:{id:this.states.id,playlist_name:this.states.playlist_name,username:this.states.username,password:this.states.password,dns:this.states.dns}})
  //       }
  //     },(error)=>{
  //       console.log(error);
        
  //     })
  //   }
  // }
  onSubmit(payload: NgForm) {
  if (this.isSubmitting || !payload.valid) return; // prevent multiple or invalid submits

  this.isSubmitting = true; // lock the submit button

  let passModel: any = {
    playlist_id: this.profile.playlist_id,
    profile_name: this.profile.profile_name,
    pin: this.profile.pin,
    parental_pin: this.profile.parental_pin,
    profile_image: this.defaultPic
  };

  this.playlistService.createProfile(passModel).subscribe({
    next: (res: any) => {
      console.log(res);
      if (res) {
        this.router.navigate(['/profile'], {
          state: {
            id: this.states.id,
            playlist_name: this.states.playlist_name,
            username: this.states.username,
            password: this.states.password,
            dns: this.states.dns
          }
        });
      }
      this.utilService.showSuccess("Profile created successfully")
    },
    error: (error) => {
      console.error(error);
    },
    complete: () => {
      this.isSubmitting = false; // unlock on complete
    }
  });
}


  selectedProfilePic(item){
    console.log(item);
    this.profilePic = item.imageUrl;
    if(this.profilePic){
      this.defaultPic = this.profilePic
    }
  }

  onSecureRadioClick(event: Event) {
  event.preventDefault(); // prevent the radio from being checked immediately
  this.setPin();          // open modal instead
  }

  setPin() {
  this.showPinModal = true;
  this.pinError = false;
   // Clear entered PIN and re-entered PIN arrays (4 empty boxes)
  this.enteredPinArray = ['', '', '', ''];
  this.reEnteredPinArray = ['', '', '', ''];
}
onDigitInput(event: any, index: number, type: 'enter' | 'reenter') {
  const input = event.target as HTMLInputElement;
  const value = input.value;

  // Allow only one digit (0–9)
  if (!/^[0-9]$/.test(value)) {
    input.value = '';
    (type === 'enter' ? this.enteredPinArray : this.reEnteredPinArray)[index] = '';
    return;
  }

  const inputs = document.querySelectorAll(`.${type}-pin`) as NodeListOf<HTMLInputElement>;
  if (index < inputs.length - 1) {
    setTimeout(() => inputs[index + 1].focus(), 10); // move next after a digit
  }
}

onKeyDown(event: KeyboardEvent, index: number, type: 'enter' | 'reenter') {
  const inputs = document.querySelectorAll(`.${type}-pin`) as NodeListOf<HTMLInputElement>;

  // Backspace → focus previous if current empty
  if (event.key === 'Backspace' && index > 0 && !(event.target as HTMLInputElement).value) {
    setTimeout(() => inputs[index - 1].focus(), 10);
  }

  // Left / Right arrow support
  if (event.key === 'ArrowLeft' && index > 0) {
    event.preventDefault();
    inputs[index - 1].focus();
  }

  if (event.key === 'ArrowRight' && index < inputs.length - 1) {
    event.preventDefault();
    inputs[index + 1].focus();
  }
}

savePin() {
  const enteredPin = this.enteredPinArray.join('');
  const reEnteredPin = this.reEnteredPinArray.join('');

  if (enteredPin.length === 4 && enteredPin === reEnteredPin) {
    this.pinError = false;
    this.showPinModal = false;
    this.isSecure = true;

    this.profile.pin = enteredPin; // save pin
    // this.util.showSuccess("PIN set successfully.");
  } else {
    this.pinError = true;
  }
}

cancelPin() {
  this.showPinModal = false;
  this.enteredPinArray = ['', '', '', ''];
  this.reEnteredPinArray = ['', '', '', ''];
  this.pinError = false;
  this.isSecure = false;
}

  back(){
    console.log(this.states);
    
    this.router.navigate(['/profile'],{state:{id:this.states.id,playlist_name:this.states.playlist_name,username:this.states.username,password:this.states.password,dns:this.states.dns}})
  }

}
